import axios from 'axios';
import { CreateMasterPlan } from '../models/masterPlanModel';

const loadAbort = () => {
  return new AbortController();
};

export const getCharacteristicsMasterPlanEndpoint = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/master-plan-characteristics`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getMasterPlanProjectEndpoint = (
  projectId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createMasterPlanProjectEndpoint = (
  projectId: string,
  payload: CreateMasterPlan,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      }),
    controller,
  };
};

export const updateMasterPlanProjectEndpoint = (
  projectId: string,
  masterPlanId: string,
  payload: CreateMasterPlan,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan/${masterPlanId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      }),
    controller,
  };
};

export const uploadMasterPlanCoverEndpoint = (
  projectId: string,
  masterPlanId: string,
  form: any,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan/${masterPlanId}/upload-cover`,
        data: form,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getMasterPlanIndicatorsEndpoint = (token: string, type?: string) => {
  const controller = loadAbort();
  const query = type ? `?type=${type}` : '';
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/project-indicators${query}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const updateMasterPlanIndicatorsEndpoint = (
  projectId: string,
  masterPlanId: string,
  payload: { indicators: string[] },
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        // TODO: replace with the real endpoint URL
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan/${masterPlanId}/indicators`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      }),
    controller,
  };
};

export const uploadMasterPlanBlueprintsEndpoint = (
  projectId: string,
  masterPlanId: string,
  form: any,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan/${masterPlanId}/upload-blueprints`,
        data: form,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const deleteMasterPlanBlueprintEndpoint = (
  projectId: string,
  masterPlanId: string,
  payload: { path: string },
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'delete',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan/${masterPlanId}/blueprints`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      }),
    controller,
  };
};

export const deleteAllMasterPlanBlueprintsEndpoint = (
  projectId: string,
  masterPlanId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'delete',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/master-plan/${masterPlanId}/blueprints/all`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
